import { Empty, type EmptyProps } from 'antd';
import cn from 'classnames';
import styles from './Empty.module.scss';

export const AppEmpty = (props: EmptyProps) => {
  return <Empty {...props} className={cn(styles.empty, props.className)} />;
};
